import React from "react";
import IconExcel from "../images/dashboard/icon-excel.png";

const DownloadSampleFile = ({ fileName = "Sample_File.xlsx", displayText = "Download Sample File" }) => {

    const handleDownload = () => {
        const timestamp = new Date().getTime();
        const fileUrl = `/${fileName}?v=${timestamp}`;
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <p className="text-primary fw-bold mt-1 text-decoration-underline" onClick={handleDownload} style={{ cursor: "pointer", fontSize: '14px' }}>
            <img src={IconExcel} alt="icon" style={{ marginRight: 5 }} />{displayText}
        </p>
    );
};

export default DownloadSampleFile;
